let productInformationSheetObjectURL;
let linkList = [];

async function getBase64LabelByRegistrationNumber(eprelNumber) {
  const response = await fetch(`/apps/energy-label/api/products/${eprelNumber}/labels`);
  const label = await response.json();
  return label;
}

async function insertEnergyLabelImage(parentElementIndex, eprelNumber) {
  const label = await getBase64LabelByRegistrationNumber(eprelNumber)
  document.querySelector(`.energy-label__overlay[data-index="${parentElementIndex}"]`).querySelector('.energy-label__image').src = label.base64
}

async function handleBadgeClick(event) {
  event.preventDefault();
  const parentElement = event.target.closest('.energy-badge__unit');
  const parentElementIndex = parentElement.dataset.index;
  const eprelNumber = parentElement.dataset.eprel;
  showOverlay(parentElementIndex)
  const labelImageSource = document.querySelector(`.energy-label__overlay[data-index="${parentElementIndex}"]`).querySelector('.energy-label__image').src
  const labelImageIsAlreadyLoaded = labelImageSource.includes('data:image/png;base64')
  if (!labelImageIsAlreadyLoaded) await insertEnergyLabelImage(parentElementIndex, eprelNumber)
}

function handleOverlayClick(event) {
  const isClickedElementAnOverlay = event.target.classList.contains('energy-label__image-container')
  if (isClickedElementAnOverlay) hideOverlay(event)
}

function appendEnergyLabel(index) {
  const energyLabel = document.querySelector('.energy-label__template').content.cloneNode(true);
  energyLabel.firstElementChild.setAttribute('data-index', index);
  const body = document.querySelector('body')
  body.appendChild(energyLabel)
}

function showOverlay(index) {
  const overlayElement =  document.querySelector( `.energy-label__overlay[data-index="${index}"]`);
  if(overlayElement === null){ appendEnergyLabel(index) }
  document.querySelector( `.energy-label__overlay[data-index="${index}"]`).style.display = 'flex';
}

function hideOverlay(event) {
  event.target.closest('.energy-label__overlay').style.display = 'none';
}

function addProductInformationSheetLinkLoading(parentElement) {
  parentElement.querySelector('.energy-badge__link').classList.add('energy-badge__link--loading')
}

function removeProductInformationSheetLinkLoading(parentElement) {
  parentElement.querySelector('.energy-badge__link--loading').classList.remove('energy-badge__link--loading')
}

async function handleProductInformationSheetLinkClick(event) {
  event.preventDefault()
  const pseudoAnchor = document.createElement('a');
  const downloadLink = event.target.closest('.energy-badge__link').href;
  const parentElement = event.target.closest('.energy-badge__unit');

  let resultLink = linkList.filter( o => o.link === downloadLink);

  if( resultLink.length == 0 ){
    addProductInformationSheetLinkLoading(parentElement)
    const response = await fetch(downloadLink);
    const blob = await response.blob();
    productInformationSheetObjectURL = URL.createObjectURL(blob);
    linkList.push( { link : downloadLink, linkObject : productInformationSheetObjectURL});
    resultLink.push( { linkObject: productInformationSheetObjectURL } );
    removeProductInformationSheetLinkLoading(parentElement)
  }
  pseudoAnchor.href = resultLink[0].linkObject;
  pseudoAnchor.download = 'product-information-sheet.pdf'
  pseudoAnchor.click();
}

class ProductPageVariantEnergyLabel extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  async init(){
    let self = this;
    //document.addEventListener('DOMContentLoaded', function() {

      const currentProductPageScript = document.querySelector('[data-productId]')
      const productId = currentProductPageScript.getAttribute('data-productId');
      const productVariants = await self.checkProductVariants(productId);

      let variantSelector = document.querySelector('form[action*="cart/add"]').querySelector("input[name='id']");
      if(!variantSelector){
        variantSelector = document.querySelector('form[action*="cart/add"]').querySelector("select[name='id']");
      }

      const energyBadgeContainer = document.querySelector('.energy-badge__container.single-product');
      if(variantSelector && productVariants){
        self.updateEnergyLabelContent(variantSelector.value);
      }else{
        energyBadgeContainer.style.display = 'flex';
      }

      if (variantSelector && productVariants) {

        const observer = new MutationObserver(() => {
          console.log('Variant ID changed:', variantSelector.value);
          self.updateEnergyLabelContent(variantSelector.value);
        });
        observer.observe(variantSelector, { attributes: true, attributeFilter: ['value'] });

        // variantSelector.addEventListener('change', function() {
        //   self.updateEnergyLabelContent(this.value);
        // });
      }
   // });
  }

  async checkProductVariants(productId){
    const variantsExist = await await fetch(`/apps/energy-label/api/products/${productId}/check-variants`).then(response => response.json());
     if(variantsExist.variants == 1){
       return true;
     }
     return false;
  }

  async updateEnergyLabelContent(variantId) {
    const badge = await this.getBadgeByRegistrationNumber(variantId)
    if(!badge){
      const energyBadgeContainer = document.querySelector('.energy-badge__container.single-product');
      energyBadgeContainer.innerHTML = '';
      return;
    }
    this.appendEnergyBadge(badge)
    return;
  }

  appendEnergyBadge(badge) {
    let energyBadge = document.querySelector('.energy-badge__template').content.cloneNode(true);
    energyBadge.firstElementChild.setAttribute('data-index', badge.eprel_number);
    energyBadge.firstElementChild.setAttribute('data-eprel', badge.eprel_number);
    energyBadge.querySelector('.energy-badge__image').src = badge.badge.base64 || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCA0MCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAwTDAgMTFMMTAgMjJINDBWMEgxMFpNMzEuNSAyMVYxSDM5VjIxSDMxLjVaTTI1LjM1MzUgNi4zNTM1M0wyMC43MDcxIDExTDI1LjM1MzUgMTUuNjQ2NEwyNC42NDY0IDE2LjM1MzVMMjAgMTEuNzA3MUwxNS4zNTM1IDE2LjM1MzVMMTQuNjQ2NCAxNS42NDY0TDE5LjI5MjkgMTFMMTQuNjQ2NCA2LjM1MzUzTDE1LjM1MzUgNS42NDY0MkwyMCAxMC4yOTI5TDI0LjY0NjQgNS42NDY0MkwyNS4zNTM1IDYuMzUzNTNaIiBmaWxsPSIjNzY3Njc2Ii8+Cjwvc3ZnPg=='
    if (!badge.badge.error && badge.eprel_number) energyBadge.querySelector('.energy-badge__link').href = `/apps/energy-label/api/products/${badge.eprel_number}/sheets`
    if (badge.badge.error) this.disableEnergyBadge()
    const energyBadgeContainer = document.querySelector('.energy-badge__container.single-product');
    energyBadgeContainer.innerHTML = '';
    energyBadgeContainer.appendChild(energyBadge)
    energyBadgeContainer.style.display = 'flex';
  }

  disableEnergyBadge() {
    document.querySelector('.energy-badge__container.single-product').classList.add('energy-badge__container--disabled')
  }

  async getBadgeByRegistrationNumber(variantId) {
    const response = await fetch(`/apps/energy-label/api/products/badges`,{
      method: "POST",
      body: JSON.stringify({ 'typeData' : 'variant', 'data' : variantId})
    })
    const badges = await response.json()
    return badges
  }

}
customElements.define('product-page-variant-energy-label', ProductPageVariantEnergyLabel)